import { gql } from '@apollo/client';

export const GET_ALL_APPLICATION_NUMBERS = gql`
   query GetAllApplicationNumbers {
      getAllApplicationDetails {
         applicationNumber
         status
         currentStage
      }
   }
`;

export const GET_ALL_OOPS = gql`
   query GetAllOOPs {
      getAllOOPs {
         id
         billNo
         applicationNumber
         OOPstatus
      }
   }
`;

export const GET_ALL_PERMITS = gql`
   query GetAllPermits {
      getAllPermits {
         id
         applicationNumber
         applicationType
         status
         currentStage
         dateOfSubmission
      }
   }
`;